import Backbone from 'backbone';
import _ from 'underscore';
import ComponentBase from 'components/_base/ComponentBase';
import { HOTEL_DETAILS } from '../../globals/widgetTypes';

const JPNonTransitStepsInfo = ComponentBase.extend(
    {
        template: require('./jpNonTransitStepsInfo.hbs'),

        componentClass: 'jp-non-transit-steps-info',

        identifier: 'jp-non-transit-steps-info',

        constructor(options) {
            options.identifier = this.identifier;
            ComponentBase.prototype.constructor.call(this, options);
            this.widget = options.widget;
            this.componentConstructorClass = options.componentConstructorClass;
            this.travelMode = options.properties.travelMode;
            this.route = options.properties.route;
            this.summary = options.properties.summary;
        },

        initialize(options = {}) {
            let componentClass = 'jp-non-transit-steps-info';
            this.templateConfig = _.extend(options, {
                componentClass: componentClass,
                originText: options.properties.originText,
                destinationText: options.properties.destinationText,
                route: options.properties.route,
                isDetailHotelWidget: this.widget.typeWidget === HOTEL_DETAILS,
                originIsMainHotel: this.widget.typeWidget === HOTEL_DETAILS && options.properties.originIsMainHotel,
                destinationIsMainHotel: this.widget.typeWidget === HOTEL_DETAILS && !options.properties.originIsMainHotel
            });
            Backbone.View.prototype.initialize.call(this, options);
            this.render();
        },
    }
);
export default JPNonTransitStepsInfo;


// WEBPACK FOOTER //
// ./src/components/JPNonTransitStepsInfo/JPNonTransitStepsInfo.js